module.exports = __webpack_public_path__ + "img/p-11-1.48897f3b.png";